module.exports = __webpack_public_path__ + "static/person-8-70x70-6c4aa5cd7b46b45249f5a33f3ce14b2a.png";